export type FeedStatus = "突发" | "追踪中" | "已澄清" | "已完结";

export interface FeedItem {
  id: string;
  time: string;
  date: string;
  title: string;
  summary: string;
  status: FeedStatus;
  category: string;
  heat: number;
  source: string;
  progress: string[];
}

export const siteBrand = {
  name: "黑料今日",
  slogan: "今日爆料 · 第一时间看到正在热聊的那一条",
  intro:
    "黑料今日是一个以「实时滚动」为核心的娱乐热点资讯站。我们把正在发酵的事件进展按时间线整理出来，标注每一条信息的状态，让你随时跟得上最新的讨论进度。",
  email: "contact@heiliaojinri.media",
  since: "2023",
};

export const tickerItems = [
  "新剧《长夜灯火》官方确认调整上线档期",
  "夏日音乐节完整阵容曝光，加场场次同步公布",
  "综艺《三餐四季》第三期录制路透流出",
  "短剧《回声岛》出品方就版权问题发布说明",
  "某演员工作室回应番位讨论：以作品本身为准",
  "动画电影《云上城池》宣布定档国庆档",
  "音乐平台与三家唱片公司达成新一轮版权合作",
  "选秀节目《声浪计划》公布投票规则调整方案",
];

export const feedItems: FeedItem[] = [
  {
    id: "f-01",
    time: "14:32",
    date: "今日",
    title: "新剧《长夜灯火》官方确认调整上线档期",
    summary:
      "出品方在官方账号发布简短说明，称因后期调色与配乐工作尚未收尾，原定本周上线的剧集将顺延。平台方表示不会影响后续排播节奏，具体时间待定。",
    status: "突发",
    category: "剧集动态",
    heat: 9832,
    source: "剧集官方账号",
    progress: [
      "14:02 有网友发现平台排播表出现空档",
      "14:18 剧集超话讨论量快速上升",
      "14:32 出品方发布正式说明，确认顺延",
    ],
  },
  {
    id: "f-02",
    time: "13:47",
    date: "今日",
    title: "夏日音乐节完整阵容曝光，加场场次同步公布",
    summary:
      "主办方放出完整海报，除此前预告的六组乐队外，另有三组独立音乐人加入。因首轮门票售罄速度较快，主办方追加一场同日演出。",
    status: "追踪中",
    category: "音乐现场",
    heat: 8210,
    source: "主办方公告",
    progress: [
      "12:30 首轮门票开售，10 分钟内售罄",
      "13:10 主办方海报释出完整阵容",
      "13:47 官方确认追加同日夜场",
    ],
  },
  {
    id: "f-03",
    time: "13:05",
    date: "今日",
    title: "短剧《回声岛》出品方就版权问题发布说明",
    summary:
      "针对近期关于改编授权的讨论，出品方发布声明，表示已完成相关授权文件的核查，并将保留对不实信息追究的权利。原著方暂未进一步回应。",
    status: "突发",
    category: "版权合约",
    heat: 7465,
    source: "出品方声明",
    progress: [
      "11:40 原著读者社群出现授权质疑讨论",
      "12:25 相关话题进入热搜榜单",
      "13:05 出品方发布说明文件",
    ],
  },
  {
    id: "f-04",
    time: "12:28",
    date: "今日",
    title: "某演员工作室回应番位讨论：以作品本身为准",
    summary:
      "工作室在评论区置顶回复，希望观众把注意力放回角色与剧情，不参与排位相关的比较。剧组随后转发该回复，表示会专注创作。",
    status: "已澄清",
    category: "剧集动态",
    heat: 6903,
    source: "工作室账号",
    progress: [
      "10:50 物料海报引发排位讨论",
      "11:55 话题阅读量突破千万",
      "12:28 工作室置顶回应，事件降温",
    ],
  },
  {
    id: "f-05",
    time: "11:52",
    date: "今日",
    title: "综艺《三餐四季》第三期录制路透流出",
    summary:
      "多位参与录制的路人账号发布现场照片，节目组尚未回应新一季嘉宾阵容是否固定。从路透看，本期录制地点为沿海小城的一处旧厂房。",
    status: "追踪中",
    category: "综艺录制",
    heat: 6120,
    source: "现场路透",
    progress: [
      "10:20 首批现场照片出现",
      "11:15 节目官微发布录制花絮片段",
      "11:52 路透讨论进入平台热榜前十",
    ],
  },
  {
    id: "f-06",
    time: "10:36",
    date: "今日",
    title: "动画电影《云上城池》宣布定档国庆档",
    summary:
      "片方发布定档预告，公布主要配音班底，导演在采访中提到本片的视觉风格参考了传统壁画的色彩层次。预售暂未开启。",
    status: "已完结",
    category: "电影资讯",
    heat: 5744,
    source: "片方发布会",
    progress: [
      "09:30 预告片上线，播放量攀升",
      "10:10 导演采访内容释出",
      "10:36 官方确认档期，事件告一段落",
    ],
  },
  {
    id: "f-07",
    time: "09:58",
    date: "今日",
    title: "音乐平台与三家唱片公司达成新一轮版权合作",
    summary:
      "平台方在年度内容会上宣布合作范围扩大，涵盖部分经典专辑的高解析版本。业内人士认为这将影响后续的会员权益结构。",
    status: "追踪中",
    category: "音乐现场",
    heat: 4890,
    source: "平台内容会",
    progress: [
      "09:15 合作消息在行业媒体流出",
      "09:40 平台方确认合作范围",
      "09:58 高解析音质权益成为讨论焦点",
    ],
  },
  {
    id: "f-08",
    time: "09:12",
    date: "今日",
    title: "选秀节目《声浪计划》公布投票规则调整方案",
    summary:
      "节目组回应此前的投票公平性讨论，公布新的计票方式与公示周期。新规自下一期开始执行，往期结果不做追溯。",
    status: "已澄清",
    category: "综艺录制",
    heat: 4218,
    source: "节目官方公告",
    progress: [
      "08:20 观众反馈投票页面显示异常",
      "08:50 节目组承认统计口径存在差异",
      "09:12 发布新规并致歉说明",
    ],
  },
  {
    id: "f-09",
    time: "昨日 22:40",
    date: "昨日",
    title: "演唱会门票退改规则更新，新增临期提醒",
    summary:
      "票务平台更新了退改说明，对临期退票增加分级提示，并在购票页显著位置展示。多家主办方表示将同步执行新规则。",
    status: "已完结",
    category: "音乐现场",
    heat: 3960,
    source: "票务平台公告",
    progress: [
      "昨日 20:10 用户集中反馈退改提示不明显",
      "昨日 21:30 平台更新规则页面",
      "昨日 22:40 新规则正式生效",
    ],
  },
  {
    id: "f-10",
    time: "昨日 20:15",
    date: "昨日",
    title: "国风舞台剧《山河引》开启第二轮巡演",
    summary:
      "剧组公布巡演城市与开票时间，首站定于下月中旬。舞美设计较首轮有较大调整，加入了更多可移动舞台装置。",
    status: "追踪中",
    category: "舞台演出",
    heat: 3325,
    source: "剧组巡演公告",
    progress: [
      "昨日 18:40 巡演城市名单流出",
      "昨日 19:30 官方公布开票时间",
      "昨日 20:15 首站预约人数快速上涨",
    ],
  },
];

export interface HotItem {
  id: string;
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: "up" | "flat" | "down";
  daily: boolean;
}

export const hotItems: HotItem[] = [
  { id: "h-01", rank: 1, title: "长夜灯火档期调整说明", tag: "剧集", heat: "983.2万", trend: "up", daily: true },
  { id: "h-02", rank: 2, title: "夏日音乐节追加夜场", tag: "音乐", heat: "821.0万", trend: "up", daily: true },
  { id: "h-03", rank: 3, title: "回声岛授权文件核查", tag: "版权", heat: "746.5万", trend: "up", daily: true },
  { id: "h-04", rank: 4, title: "番位讨论工作室回应", tag: "剧集", heat: "690.3万", trend: "down", daily: true },
  { id: "h-05", rank: 5, title: "三餐四季录制路透", tag: "综艺", heat: "612.0万", trend: "flat", daily: true },
  { id: "h-06", rank: 6, title: "云上城池定档国庆", tag: "电影", heat: "574.4万", trend: "up", daily: false },
  { id: "h-07", rank: 7, title: "音乐版权合作扩容", tag: "音乐", heat: "489.0万", trend: "flat", daily: false },
  { id: "h-08", rank: 8, title: "声浪计划投票新规", tag: "综艺", heat: "421.8万", trend: "down", daily: false },
  { id: "h-09", rank: 9, title: "票务退改规则更新", tag: "演出", heat: "396.0万", trend: "flat", daily: false },
  { id: "h-10", rank: 10, title: "山河引二轮巡演", tag: "舞台剧", heat: "332.5万", trend: "up", daily: false },
];

export interface TopicItem {
  id: string;
  name: string;
  count: number;
  desc: string;
  icon: string;
}

export const topics: TopicItem[] = [
  { id: "t-1", name: "剧集动态", count: 186, desc: "排播、物料、角色讨论的集中地带", icon: "ri-tv-2-line" },
  { id: "t-2", name: "综艺录制", count: 142, desc: "节目路透、赛制与嘉宾动向追踪", icon: "ri-mic-line" },
  { id: "t-3", name: "音乐现场", count: 128, desc: "音乐节、巡演、开票与版权消息", icon: "ri-music-2-line" },
  { id: "t-4", name: "电影资讯", count: 96, desc: "定档、预告、票房与主创采访", icon: "ri-film-line" },
  { id: "t-5", name: "版权合约", count: 74, desc: "授权、合约与行业规范相关进展", icon: "ri-file-list-3-line" },
  { id: "t-6", name: "舞台演出", count: 61, desc: "巡演、票务与线下演出安排", icon: "ri-ticket-2-line" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "黑料今日的内容是从哪里整理的？",
    a: "我们只汇总公开可查的讨论与官方发布口径，把零散信息按时间顺序整理成一条条可追踪的进展，并注明信息状态。对于没有可靠出处的说法，我们不会收录。",
  },
  {
    q: "页面上的「突发」「追踪中」标签代表什么？",
    a: "「突发」表示事件刚刚出现、还在快速变化；「追踪中」表示我们正在持续跟进并补充进展；「已澄清」表示当事方或官方已给出说明；「已完结」表示该条信息不再有新的进展。",
  },
  {
    q: "热点榜单多久更新一次？",
    a: "日榜随页面内容实时刷新，周榜每天上午整体重排一次。排名依据是同一话题在全网公开讨论中的增长速度，而不是单纯的总量。",
  },
  {
    q: "可以提交自己看到的热点线索吗？",
    a: "可以通过页面底部的订阅入口留下联系方式，备注你想跟进的话题。我们会优先整理有明确出处、且讨论已经形成规模的线索。",
  },
  {
    q: "为什么不直接给出结论？",
    a: "很多事件在早期并没有定论。与其替用户下判断，我们更愿意把每一步进展和状态标清楚，让读者自己判断信息走到了哪一步。",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "林一诺",
    role: "追剧党 · 杭州",
    text: "以前刷热点要来回切好几个平台，现在打开这一页就能看到时间线，哪一步更新到哪一目了然。",
  },
  {
    name: "赵沐",
    role: "乐迷 · 成都",
    text: "开票和加场的信息基本没漏过，最实用的是它会标「已完结」，不用一直惦记着刷新。",
  },
  {
    name: "陈迦",
    role: "内容运营 · 深圳",
    text: "做选题时我会先来这里看一圈，进展节点的梳理比零散截图清楚得多，省了很多核对时间。",
  },
];

export const statusMeta: Record<FeedStatus, { desc: string; dot: string; chip: string }> = {
  突发: {
    desc: "刚刚出现，还在快速变化",
    dot: "bg-primary-500",
    chip: "bg-primary-100 text-primary-800 border-primary-200",
  },
  追踪中: {
    desc: "持续跟进，进展陆续补充",
    dot: "bg-accent-500",
    chip: "bg-accent-100 text-accent-900 border-accent-300",
  },
  已澄清: {
    desc: "当事方或官方已作出说明",
    dot: "bg-secondary-500",
    chip: "bg-secondary-100 text-secondary-900 border-secondary-200",
  },
  已完结: {
    desc: "暂无新的进展，进入沉淀",
    dot: "bg-foreground-400",
    chip: "bg-foreground-100 text-foreground-700 border-foreground-200",
  },
};